<div class="pagecontent">
    <h1 class="header1">Passenger Information</h1>
    <h2 class="header2">Please enter the passenger information below</h2>
    <div class="passenger-content">
        <div formGroupName="tripRequest">
            <div class="passenger-row">
                <div class="form-field">
                    <fieldset class="radio-fieldset">
                        <legend id="anotherMedicaidConsumer">Are there any other medicaid consumers traveling to the appointment?</legend>
                        <mat-radio-group formControlName="anotherMedicaidConsumer" (change)="onMedicaidConsumerChange($event)" aria-labelledby="anotherMedicaidConsumer">
                            <mat-radio-button [value]='true' aria-label="Yes, additional medicaid consumer traveling with this appointment">Yes</mat-radio-button>
                            <mat-radio-button [value]='false' aria-label="No, additional medicaid consumer traveling with this appointment">No</mat-radio-button>
                        </mat-radio-group>
                    </fieldset>
                </div>
            </div>
            @if(tripRequestFg.get("anotherMedicaidConsumer")?.value && appointmentDatesFr.length == 1) {
                @for (date of tripPassengerFr.controls; track date; let k = $index) {
                    <div  formArrayName="tripPassengers"> 
                        <div [formGroupName] = "k" >
                            <div class="passenger-row">
                                <div class="form-field">
                                    <label [for]="'passengerFirstName_trip'+k" >First Name <span class="star">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input [id]="'passengerFirstName_trip'+k" formControlName="firstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                                        @if (hasError(`tripPassengers.${k}.firstName`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <div class="form-field">
                                    <label [for]="'passengerLastName_trip'+k">Last Name <span class="star">*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input [id]="'passengerLastName_trip'+k" formControlName="lastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher"/>
                                        @if (hasError(`tripPassengers.${k}.lastName`, 'required')) {
                                            <mat-error>This field is required.</mat-error>
                                        }
                                    </mat-form-field>
                                </div>
                                <div class="remove-passenger">
                                    <a tabindex="0" role="button" (click)="removeTripPassenger(k)" (keydown.enter)="removeTripPassenger(k)">
                                    <span>
                                        <mat-icon aria-hidden="false" aria-label="Remove Passenger">remove_circle_outline</mat-icon>
                                    </span>
                                    </a>
                                </div>                               
                            </div>
                        </div>
                    </div>                        
                }
                <div class="add-passenger">
                    <a tabindex="0" role="button" (click)="addTripPassenger()" (keydown.enter)="addTripPassenger()">
                        <span>Add Additional Passenger</span>
                        <span >
                            <mat-icon class="add-passenger-icon" aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                        </span>
                    </a>
                </div>
            }
            @if (appointmentDatesFr.length > 1 && tripRequestFg.get('anotherMedicaidConsumer')?.value) {
                <div class="passenger-row">
                    <div class="form-field">
                        <fieldset class="radio-fieldset">
                             <legend id="samePassenger">Is the passenger same for all appointments?</legend>
                            <mat-radio-group formControlName="samePassenger" aria-labelledby="samePassenger" (change)="onSamePassengerChange($event)">
                                <mat-radio-button [value]='true' aria-label="Yes, the same passenger is used for all appointments">Yes</mat-radio-button>
                                <mat-radio-button [value]='false' aria-label="No, different passenger are used for appointments">No</mat-radio-button>
                            </mat-radio-group>
                        </fieldset>
                    </div>
                </div>
                @if (!tripRequestFg.get('samePassenger')?.value) {
                    @for (date of appointmentDatesFr.controls; track date; let i = $index) {
                        <div  formArrayName="tripAppointments">   
                            <div  [formGroupName]="i" >
                                @if(!tripRequestFg.get("samePassenger")?.value) {
                                    <div class="trip-appointment-date-container">
                                        <span class="appointment-date">Appointment: {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} 
                                                at {{ date.get('appointmentDate')?.value | date: 'shortTime'}}</span>
                                    </div>
                                    @for (address of getPassenger(i).controls; track address; let j = $index) {
                                        <div formArrayName="appointmentPassengers">   
                                            <div  [formGroupName]="j" >
                                                <div class="passenger-row">
                                                    <div class="form-field">
                                                        <label [for]="'firstName'+i+'-'+j" >First Name <span class="star">*</span></label>
                                                        <mat-form-field appearance="outline">
                                                            <input [id]="'firstName'+i+'-'+j" formControlName="firstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                                                            @if (hasError(`tripAppointments.${i}.appointmentPassengers.${j}.firstName`, 'required')) {
                                                                <mat-error>This field is required.</mat-error>
                                                            }
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="form-field">
                                                        <label [for]="'lastName'+i+'-'+j">Last Name <span class="star">*</span></label>
                                                        <mat-form-field appearance="outline">
                                                            <input [id]="'lastName'+i+'-'+j" formControlName="lastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher" />
                                                            @if (hasError(`tripAppointments.${i}.appointmentPassengers.${j}.lastName`, 'required')) {
                                                                <mat-error>This field is required.</mat-error>
                                                            }
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="remove-passenger">
                                                        <a tabindex="0" role="button" (click)="removePassenger(i, j)" 
                                                        (keydown.enter)="removePassenger(i, j)">
                                                        <span>
                                                            <mat-icon aria-hidden="false" aria-label="Remove Passenger">remove_circle_outline</mat-icon>
                                                        </span>
                                                        </a>
                                                    </div>                               
                                                </div>
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                        @if(!tripRequestFg.get("samePassenger")?.value) {
                            <div class="add-passenger">
                                <a tabindex="0" role="button" (click)="addPassenger(i)" (keydown.enter)="addPassenger(i)">
                                    <span>Add Additional Passenger</span>
                                    <span >
                                        <mat-icon class="add-passenger-icon" aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                                    </span>
                                </a>
                            </div>
                        }
                    } 
                }
                @else {
                    @for (date of tripPassengerFr.controls; track date; let k = $index) {
                        <div  formArrayName="tripPassengers"> 
                            <div [formGroupName] = "k" >
                                <div class="passenger-row">
                                    <div class="form-field">
                                        <label [for]="'passengerFirstName_trip'+k" >First Name <span class="star">*</span></label>
                                        <mat-form-field appearance="outline">
                                            <input [id]="'passengerFirstName_trip'+k" formControlName="firstName" matInput placeholder="Enter First Name" [errorStateMatcher]="matcher" />
                                            @if (hasError(`tripPassengers.${k}.firstName`, 'required')) {
                                                <mat-error>This field is required.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="form-field">
                                        <label [for]="'passengerLastName_trip'+k">Last Name <span class="star">*</span></label>
                                        <mat-form-field appearance="outline">
                                            <input [id]="'passengerLastName_trip'+k" formControlName="lastName" matInput placeholder="Enter Last Name" [errorStateMatcher]="matcher"/>
                                            @if (hasError(`tripPassengers.${k}.lastName`, 'required')) {
                                                <mat-error>This field is required.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="remove-passenger">
                                        <a tabindex="0" role="button" (click)="removeTripPassenger(k)" 
                                        (keydown.enter)="removeTripPassenger(k)">
                                        <span>
                                            <mat-icon aria-hidden="false" aria-label="Remove Passenger">remove_circle_outline</mat-icon>
                                        </span>
                                        </a>
                                    </div>                               
                                </div>
                            </div>
                        </div>                        
                    }
                    <div class="add-passenger">
                        <a tabindex="0" role="button" (click)="addTripPassenger()" (keydown.enter)="addTripPassenger()">
                            <span>Add Additional Passenger</span>
                            <span >
                                <mat-icon class="add-passenger-icon" aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                            </span>
                        </a>
                    </div>
                }
            }              
        </div>
    </div>
</div>